import * as React from 'react';

import { useSafeLayoutEffect } from './useSafeLayoutEffect';

/**
 * Returns the value of the previous render.
 */
export function usePrevious<T>(value: T): T | undefined {
    const ref = React.useRef<T | undefined>(undefined);
    useSafeLayoutEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
